export const images = {
  LOGO: '/media/logo/logo-v-black.svg',
  BG: '/media/bg/auth_blue_bg.jpg',
};
